import React, { FC, useState } from 'react';
import { Icon } from 'common-components';
import { MenuItem, Menu, Button, ListItemIcon, ExpandMoreIcon } from '../../uiLibraryImports';
import { SelectMenuTypes } from './selectTypes';
import styles from './select.module.scss';

const SelectMenu: FC<SelectMenuTypes> = (props: SelectMenuTypes) => {
    const { title, optionsList, selectRef, icon = 'plusIcon', customizedButton, wrapperCX } = props;
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={wrapperCX}>
            {customizedButton ? (
                React.cloneElement(customizedButton, { onClick: handleClick })
            ) : (
                <Button
                    className={styles['select-button-wrapper']}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <Icon name={icon} className={styles['plus-icon']} />
                    <div className={styles.text}>{title}</div>
                    <div className={styles.dash}></div>

                    <ExpandMoreIcon className={anchorEl ? styles['up-icon'] : styles['down-icon']} />
                </Button>
            )}
            <Menu
                id="simple-menu"
                ref={selectRef}
                classes={{ paper: styles.paper, list: styles.list }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={styles['inner-select-wrapper']}
            >
                {optionsList.map((option, index) => {
                    return (
                        <MenuItem
                            key={index}
                            ref={option.menuItemRef}
                            onClick={() => {
                                option.onClick();
                                handleClose();
                            }}
                            disabled={option.isDisabled}
                            className={styles.menu}
                        >
                            {option.icon && (
                                <ListItemIcon className={styles.icon}>
                                    <Icon name={option.icon} />
                                </ListItemIcon>
                            )}
                            <div className={styles['options-text']}>{option.text}</div>
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>
    );
};

export default SelectMenu;
